import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    rowGap: "1px",
    justifyContent: "center",
    overflow: "auto hidden",
  },
});
